// eslint-disable-next-line import/prefer-default-export
export const firebaseActionCodeSettings = {
  // URL you want to redirect back to. The domain (www.example.com) for this
  // URL must be in the authorized domains list in the Firebase Console.
  url: `${window.location.origin}/verifyLink`,
  // This must be true.
  handleCodeInApp: true,
}
